import {Vehicle} from './vehicle.model';

export class Vehiclecontainer {
  message: string;
  veh: Vehicle[];

  constructor() {
  }

  deserialize(input: any) {
    (<any>Object).assign(this, input);
    this.veh = input.vehicles.map((item) => new Vehicle().deserialize(item));
    return this;
  }
}
